import axios from "axios";
import qs from "qs";

import { api } from "@/plugins/util";

/**
 * 搜索文
 * @param word         企业名称
 * @param pageNum       页数
 * @param pageSize      每页显示数量
 * @returns {AxiosPromise<any>}
 */
export function search({word,
                           pageNum,
                           pageSize
                       }) {
    return axios.post(api + "/creditReport/search", qs.stringify({
        word,
        pageNum,
        pageSize
    }))
}

/**
 * @param word 统一社会信用代码
 * @param pageNum
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function search2({word,
                            pageNum,
                            pageSize
                        }) {
    return axios.post(api + "/creditReport/search2", qs.stringify({
        word,
        pageNum,
        pageSize
    }))
}
/**
 * 获取档案
 *
 */
export function getDa(uscc,name) {
    return axios.post(api + "/creditReport/getDetail", qs.stringify({
       uscc,
        name
    }))
}
